export const PAYMENT = `GST20000`; // Grupo Pagamento
export const SCHEDULE = `GST21000`; // Grupo Agendamento
export const EVENTS = `GST22000`; // Grupo Atendimento
export const PERSON = `GST24000`; // Grupo de status person
export const ORDER = `GST25000`; // Grupo Pedido
export const MEDICAL_REQUEST = `GST26000`;
